import {
  BleSendV2,
  BleV2DeviceProtocol,
  BleV2DeviceProtocolBeginSeal,
  BleV2DeviceProtocolOperation
} from "@hybird/device/protocol/blev2";
import {DeviceEvent} from "@hybird/core/device/protocol";
import {BleDeviceConnectProvide} from "@hybird/device/protocol/ble";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import md5 from "md5";

class SerialSendV2 extends BleSendV2 {

  connectType = 4;

  async onDisconnect() {
    await super.onDisconnect();

    await this.listen(this.deviceProtocol.serviceName.USERLOGOUT, {
      cacheTopic: false,
      message: data => {
        if (!data.reply) {
          this.deviceProtocol.disconnect({force: true, logout: true, type: 3, connectType: 4});
          this.deviceProtocol.online = false;
        }
      }
    });
  }

  createKeepAlive() {
    this.clearKeepAlive = () => {
    };
  }

  async userLogout() {
    return this.service(this.deviceProtocol.serviceName.USERLOGOUT, []);
  }
}

class SerialDeviceProtocol extends BleV2DeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption, codec = SerialSendV2) {
    super(deviceProvide, deviceInfo, deviceProtocolOption, codec);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new SerialDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new SerialDeviceProtocolOperation(this.deviceInfo, this);
  }

  get serviceName() {
    const serviceName = super.serviceName;
    return Object.assign(serviceName, {
      DEVICEINFOGET: "DEVICEINFOGETV2",
    });
  }

  get connectType() {
    return 4;
  }

  async _connect({success, sync, complete, message, fail, timeout = 20} = {}) {
    this.emit(DeviceEvent.BEFORE_USER_LOGIN);

    this.deviceConnectProvide.codec = this.codec;
    const info = await this.info();
    console.log(info);

    if (!info.number.includes(this.deviceInfo.number)) {
      throw WebError.code(deviceError.SERIAL_NOT_NUMBER_CONNECT, {format: [info.number, this.deviceInfo.number]});
    }

    let getSign;
    if (this.deviceInfo.deviceSecret) {
      const timestamp = new Date().getTime();
      const signStr = `${this.deviceInfo.deviceSecret}&${this.deviceInfo.staffId}&${this.deviceInfo.userName}`
      const sign = md5(signStr);
      console.log(sign);

      getSign = {
        userName: this.deviceInfo.userName,
        staffId: this.deviceInfo.staffId,
        timestamp,
        sign
      }
    } else {
      getSign = await this._userLoginSend(timeout)
      if (!getSign?.sign) {
        let getSign = await this._getSignSend(timeout);
        let time = getSign.timestamp.toString();
        if (time.length > 10) {
          getSign.timestamp = Number(time.substring(0, 10))
        }
      }
    }

    let data;

    const login = async () => {
      return await this.service(this.serviceName.DEVICE_MATCH, [
        getSign.userName,
        getSign.staffId,
        getSign.timestamp,
        getSign.sign,
        3,
        getSign.workbenchSn
      ], {
        success, complete, message, fail, timeout
      }).catch(e => {
        if (e instanceof WebError && e.resultCode === deviceError.PUBLISH_AND_RESULT_NOT_SUCCESS) {
          if (e.data.code === "100004") {
            return e.data;
          }
        }

        throw e;
      });
    }

    const type = parseInt(info.type);

    if (type === 0) {
      data = await login();
    } else if (type === 1) {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "特权人已登录, 请退出后连接"});
    } else if (type === 2) {
      // if (parseInt(info.id) !== this.deviceInfo.staffId) {
      //先退出登录后连接
      // await this.send.userLogout();
      data = await login();
      // }
    } else {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "连接参数异常"});
    }

    if (data?.params.length > 4) {
      const params = {
        userName: data.params[1],
        staffId: data.params[2],
        sdkVersion: data.params[3],
        energyType: parseInt(data.params[4]),
        energy: parseInt(data.params[5]),
        bleMac: data.params[6],
        plank: data.params[7],
        systemVersion: data.params[8],
        version: data.params[9],
      }

      await this._propertySyncSend(params);
    }

    if (data?.params[3]) {
      this._version = parseInt(data.params[3]);
    } else {
      this._version = 4;
    }

    this.emit(DeviceEvent.USER_LOGIN);
  }

  async _disconnect({type, logout, success, complete, message, fail, timeout} = {}) {
    try {
      await this._userLogoutSend()

      if (this.deviceConnectProvide.connected && this.deviceProtocolBeginSeal) {
        await this.deviceProtocolBeginSeal.endSeal({force: true, type, logout});
      }

      //当设备主动退出, 无需再次调用
      if (type !== 3) {
        await this.send.userLogout();
      }

      await this.send.unsubscribe();
      await success?.call(this);
      complete?.call(this);
    } catch (e) {
      fail?.call(this, e);
      complete?.call(this, null, e);
    }
  }

  info({success, complete, message, fail, timeout} = {}) {
    return this.service(this.serviceName.DEVICEINFOGET, [], {
      success, complete, message, fail, timeout
    }).then(({params}) => {
      if (params.length < 4) {
        throw WebError.code(deviceError.DEVICE_INITIALIZE);
      }
      this.deviceInfo.api =params[8]
      this.deviceInfo.iot =params[9]
      return {
        number: params[1],
        version: params[2],
        type: params[3],
        id: params[4],
        status: params[5],
      }
    })
  }

  async _precord() {
    return this._precordSize(100);
  }
}

class SerialDeviceConnectProvide extends BleDeviceConnectProvide {

  /**
   *
   * @param createBleDevice{{create:function(Config):BleDevice, isSupport: function():boolean}}
   * @param networkConnectProvide
   */
  constructor(createBleDevice, networkConnectProvide) {
    super(createBleDevice, null);
  }

  get connectType() {
    return 4;
  }
}

class SerialDeviceProtocolBeginSeal extends BleV2DeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class SerialDeviceProtocolOperation extends BleV2DeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async _firmwareUpgrade({type, localCallback, path, data, success, complete, message, fail, timeout}) {
    await super._firmwareUpgrade({type, localCallback, path, data, success, complete, message, fail, timeout});

    let clearFn;
    let timeoutIndex;

    return {
      autoReconnect: true,
      reconnect: () => {
        return new Promise((resolve, reject) => {
          //等待正常协议回调
          this.send.listen(this.deviceProtocol.serviceName.UPGRADE_PROGRESS, {
            one: true,
            message: async ({params}) => {
              const step = parseInt(params[1]);

              if (step === 3) {
                await this.deviceProtocol._connect().then(async () => {
                  this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 2, progress: 100});
                  resolve();
                }).catch(e => {
                  reject(e);
                  throw e;
                });
              } else {
                this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: -1, progress: 0});
              }
            },
            timeout: 30
          });

          clearFn = () => {
            if (timeoutIndex) {
              clearTimeout(timeoutIndex);
            }
          }

          //连接成功后, 只等30s的升级回复
          timeoutIndex = setTimeout(() => {
            reject(WebError.code(deviceError.UPGRADE_WAIT_SUCCESS_TIMEOUT));
          }, 30000);
        }).then(() => {
          this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 3, progress: 100});
          this._firmwareUpdateSend({version: data.edition});
        }).finally(() => {
          clearFn?.call(this);
        });
      }
    }
  }

  setDeviceConfig({config, success, complete, message, fail, timeout}) {
    return this.send.service(this.deviceProtocol.serviceName.DEVICEINFOSET, [config.awaitTime, config.sleepTime, config.voice, config.sealPattern], {
      success, complete, message, fail, timeout
    })
  }
}

export {
  SerialDeviceProtocol,
  SerialDeviceProtocolBeginSeal,
  SerialDeviceProtocolOperation,
  SerialDeviceConnectProvide
}